import { withInstall } from '@lit-element/utils'
import Drawer from './src/drawer.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtDrawer: SFCWithInstall<typeof Drawer> = withInstall(Drawer)
export default LtDrawer

export * from './src/drawer'
